import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { UserVaultsRows } from '../UserVaultsRows';
import { useUserVaultsSectionStyle } from './UserVaultsSection.style';
import { UserVaultsEmpty } from '../UserVaultsEmpty';
import { UserVaultsConnectWallet } from '../UserVaultsConnectWallet';

import { Store } from '@/shared/store';
import { getUserVaults } from '@/shared/store/userVaults/actions';
import { useHasUserVaultsError } from '@/shared/hooks/useErrors';
import { ServerError } from '@/widgets/ServerError';
import { TooltipWrapper } from '@/shared/ui';

export const UserVaultsSection: FC = () => {
    const classes = useUserVaultsSectionStyle();
    const dispatch = useDispatch();
    const { walletAddress, blockchainName, loading, userVaults, hasUserVaults, vaults } =
        useSelector((state: Store) => ({
            walletAddress: state.wallets.active.address,
            blockchainName: state.wallets.network,
            loading: state.userVaults.userVaultsLoading,
            userVaults: state.userVaults.userVaults,
            hasUserVaults: state.userVaults.hasUserVaults,
            vaults: state.vaults.vaults,
        }));

    const hasError = useHasUserVaultsError();

    useEffect(() => {
        dispatch(getUserVaults());
    }, [walletAddress, blockchainName, vaults]);

    const getContent = () => {
        if (!walletAddress) {
            return <UserVaultsConnectWallet />;
        }

        const notLoading = !loading && !userVaults.length;
        const userDontHaveVaults = loading && !hasUserVaults;
        if (notLoading || userDontHaveVaults) {
            return <UserVaultsEmpty />;
        }

        return (
            <div className={classes.tableWrapper}>
                <table className={classes.table}>
                    <thead>
                        <tr className={classes.tr}>
                            <th>Vault Name</th>
                            <th>Asset</th>
                            <th>Supplied Amount</th>
                            <th>
                                <div className={classes.apyTitle}>
                                    <TooltipWrapper text='Net APY is the total annual yield from your deposit, including interest and rewards.' />
                                    <span>Net APY</span>
                                </div>
                            </th>
                            <th>Curator</th>
                            <th className={classes.fixWidth}>Total Earnings</th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        <UserVaultsRows items={userVaults} />
                    </tbody>
                </table>
            </div>
        );
    };

    return (
        <div className={classes.root}>
            <div className={classes.title}>My Positions</div>
            {hasError ? <ServerError action={getUserVaults} /> : getContent()}
        </div>
    );
};
